module.exports = __webpack_public_path__ + "img/file-text.0f7319fd.svg";